import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 16.4987H8C10.4853 16.4987 12.5 14.4839 12.5 11.9987C12.5 9.51338 10.4853 7.49866 8 7.49866H8.5C9.5718 7.49866 10.5622 6.92686 11.0981 5.99866C11.634 5.07045 11.634 3.92686 11.0981 2.99866C10.5622 2.07045 9.5718 1.49866 8.5 1.49866H1.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 1.49866V16.4987",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 7.49866H3.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2218%22%20viewBox%3D%220%200%2014%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%3E%3Cpath%20d%3D%22M1.5%2016.4987H8C10.4853%2016.4987%2012.5%2014.4839%2012.5%2011.9987C12.5%209.51338%2010.4853%207.49866%208%207.49866H8.5C9.5718%207.49866%2010.5622%206.92686%2011.0981%205.99866C11.634%205.07045%2011.634%203.92686%2011.0981%202.99866C10.5622%202.07045%209.5718%201.49866%208.5%201.49866H1.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.5%201.49866V16.4987%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8%207.49866H3.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
